export const Routes = {
  home: {
    pattern: '/',
    getPath: (): string => '/',
  },
  authorizationError:{
    pattern: '/authorization-error',
    getPath: (): string => '/authorization-error'
  },
  manualInput: {
    pattern: '/manual-input',
    getPath: (): string => '/manual-input',
  },
  serviceShareInput: {
    pattern: '/service-share-input',
    getPath: (): string => '/service-share-input',
  },
  periodStatus: {
    pattern: '/period-status',
    getPath: (): string => '/period-status',
  },
  divisions: {
    pattern: '/administrator/divisions',
    getPath: (): string => '/administrator/divisions',
  },
  editDivisions: {
    pattern: '/administrator/divisions/:id/edit',
    getPath: (id: string): string => `/administrator/divisions/${id}/edit`,
  },
  brands: {
    pattern: '/administrator/brands',
    getPath: (): string => '/administrator/brands',
  },
  leadingBrands: {
    pattern: '/administrator/leading-brands',
    getPath: (): string => '/administrator/leading-brands',
  },
  countries: {
    pattern: '/administrator/countries',
    getPath: (): string => '/administrator/countries',
  },
  users: {
    pattern: '/administrator/users',
    getPath: (): string => '/administrator/users',
  },
  editUsers: {
    pattern: '/administrator/users/:id/edit',
    getPath: (id: string): string => `/administrator/users/${id}/edit`,
  },
  userAccessRights: {
    pattern: '/administrator/user-access-rights',
    getPath: (): string => '/administrator/user-access-rights',
  },
  productDetails: {
    pattern: '/administrator/product-details',
    getPath: (): string => '/administrator/product-details',
  },
  welcomeAdmin: {
    pattern: '/administrator/welcome-admin',
    getPath: (): string => '/administrator/welcome-admin',
  },
  manageReminders: {
    pattern: '/administrator/manage-reminders',
    getPath: (): string => '/administrator/manage-reminders',
    },
    notificationlogs: {
        pattern: '/administrator/notification-logs',
        getPath: (): string => '/administrator/notification-logs'
    }
};
